export const ROOT_ELEMENT_ID = 'root';
export const HTTP_STATUS_UNAUTHORIZED = 401;
export const AUTH_RETURN_TO_PARAM = 'returnTo';
